<template>    
    <router-view/> 
</template>